/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LayoutFieldsResponseDto } from '../../models/layout-fields-response-dto';

export interface ClientGetLayoutFieldsGet$Params {
  layout_uuid?: string;
}

export function clientGetLayoutFieldsGet(http: HttpClient, rootUrl: string, params?: ClientGetLayoutFieldsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LayoutFieldsResponseDto>>> {
  const rb = new RequestBuilder(rootUrl, clientGetLayoutFieldsGet.PATH, 'get');
  if (params) {
    rb.query('layout_uuid', params.layout_uuid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<LayoutFieldsResponseDto>>;
    })
  );
}

clientGetLayoutFieldsGet.PATH = '/Client/GetLayoutFields';
